import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { dataActionCreators, Product } from '../../store/Data';
import { Button, Text } from '@fluentui/react-components';
import { Dismiss24Filled } from "@fluentui/react-icons";
import { useQuickViewStyles } from '../Styles/QuickView';

export const ProductsQuickView = () => {
    const productQuickView = useSelector<ApplicationState, Product | null>((state: ApplicationState) => state.data.productQuickView);
    const dispatch = useDispatch();
    const viewDebugInfo = useSelector((state: ApplicationState) => state.userNeomyticLogin.viewDebugInfo);
    const styles = useQuickViewStyles();

    if (productQuickView) {
        return (
            <div className={styles.root} >
                <div className={styles.titleAndOps}>
                    <h2>{"Product : " + (productQuickView.displayName ? productQuickView.displayName : "?")}</h2>
                    <div className={styles.titleAndOpsButtons}>
                        <Button icon={<Dismiss24Filled />} shape="circular" title="Close" onClick={() => dispatch(dataActionCreators.requestClearQuickView())} />
                    </div>
                </div>
                {viewDebugInfo &&
                    <>
                        <h2>Id</h2>
                        <Text truncate>{productQuickView.productid}</Text>
                    </>
                }
                {productQuickView.description && <>
                    <h2>Description</h2>
                    <pre style={{ whiteSpace: "pre-wrap" }}>{productQuickView.description}</pre>
                </>}
            </div>
        );
    }
    return null;
};